import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "@/config/site";
import { Logo } from "@/components/site/Logo";
import { Footer } from "@/components/site/Footer";

const CONTENT = {
  privacy: {
    title: "Privacy",
    body: [
      "This website collects only what you choose to give us when you join the Pitchally waitlist: your email address and, optionally, your name, role, phone platform and the plan you are interested in.",
      "We use this information solely to tell you when the Pitchally app is available and to share launch updates. We do not sell your information.",
      "The Pitchally mobile app has its own privacy policy, presented when you create an account in the app.",
      `To access or delete your waitlist information, email ${CONTACT_EMAIL}.`,
    ],
  },
  terms: {
    title: "Terms",
    body: [
      "This website provides information about the Pitchally mobile app, operated by Pitchclerk Music Group.",
      "Plan names, features and prices shown here are provided for information and may change before or after launch. Subscriptions are purchased and managed inside the Pitchally app, under the terms presented there.",
      "Pitchally does not guarantee placements, streams or outcomes from any opportunity.",
      `Questions about these terms can be sent to ${CONTACT_EMAIL}.`,
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  useEffect(() => {
    document.title = `${c.title} — Pitchally`;
    window.scrollTo(0, 0);
  }, [c.title]);
  return (
    <>
      <header className="border-b border-white/10">
        <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-5 sm:px-8 lg:px-12">
          <Link to="/" aria-label="Pitchally home"><Logo testId="legal-logo" /></Link>
          <Link to="/" data-testid="legal-back-home" className="text-[13px] font-medium uppercase tracking-[0.16em] text-pa-muted hover:text-pa-ink">← Home</Link>
        </div>
      </header>
      <main data-testid={`legal-page-${page}`} className="mx-auto max-w-3xl px-5 py-24 sm:px-8">
        <h1 className="font-display text-7xl uppercase leading-none">{c.title}</h1>
        <div className="mt-10 space-y-5 text-base leading-relaxed text-pa-muted md:text-lg">
          {c.body.map((p) => <p key={p}>{p}</p>)}
        </div>
      </main>
      <Footer />
    </>
  );
}
